import { Component, OnInit, EventEmitter, Output, Input, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { BsDatepickerConfig, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from '../../../../shared/rest.service';
import { UbicacionesService } from '../../service/ubicaciones.service';
import { DatePipe } from '@angular/common';
import { searchPayload } from '../../../../utils/search-functions';
import { DISNEY } from '../../../../home/search-box/categories/disney/response/searchResponseDisney';
import { UserService } from '../../../../pages/com.usblick.common/auth/user.service';
import { ItineraryService } from '../../../../shared/itinerary.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'usb-disney',
  templateUrl: './disney.component.html',
  styleUrls: ['./disney.component.scss'],
  providers: [DatePipe]
})
export class DisneyComponent implements OnInit, OnDestroy {

  @Output() origin = new EventEmitter<any>();
  @Input() _close: boolean;
  @Output() modal = new EventEmitter<string>();
  @Output() payload = new EventEmitter<any>();
  @Output() results = new EventEmitter<any>();
  @Output() isLoading = new EventEmitter<boolean>();

  @ViewChild('dpDeparture') datepickerDeparture: BsDatepickerDirective;
  @ViewChild('dpArrival') datepickerArrival: BsDatepickerDirective;

  _form: FormGroup;
  _maxPersons: any;
  isCollapsed = false;
  _resultsQuery: any;
  minDate: Date;
  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  validate = false;
  _findData: boolean;
  roomsAndPassengers: string;

  public actividad = [
    { id: 1, name: 'Disney-World Orlando' },
    { id: 2, name: 'Disney-World California' },
  ];

  selectedActividadId: any;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private fb: FormBuilder,
    private _routeActive: ActivatedRoute,
    private _router: Router,
    private datePipe: DatePipe,
    private _restService: RestService,
    private ubicacionesService: UbicacionesService,
    public userService: UserService,
    private cdr: ChangeDetectorRef,
    private _itineraryService: ItineraryService
  ) {
    this._maxPersons = Array.from(Array(51).keys());
    this.dpConfig.containerClass = 'theme-red';
    this.minDate = new Date();
  }

  ngOnInit() {
    this.roomsAndPassengers = "Rooms and Passengers";
    this._form = this.fb.group({
      // Search basic
      arrivalDate: [null, Validators.compose([Validators.required,
      (c: FormControl) => {
        if (
          this._form !== undefined &&
          c.value !== null &&
          this._form.get('departureDate').value !== null &&
          this._form.get('departureDate').value !== undefined
        ) {
          const valid = (c.value < this._form.get('departureDate').value) ? null : { invalidDate: true };
          this._form.controls['departureDate'].setErrors(valid);
          return (c.value < this._form.get('departureDate').value) ? null : { invalidDate: true };
        }
      }
      ])],
      departureDate: [null, Validators.compose([Validators.required,
      (c: FormControl) => {
        if (
          this._form !== undefined &&
          c.value !== null &&
          this._form.get('departureDate').value !== null &&
          this._form.get('departureDate').value !== undefined
        ) {
          const valid = (c.value > this._form.get('arrivalDate').value) ? null : { invalidDate: true };
          this._form.controls['arrivalDate'].setErrors(valid);
          return (c.value > this._form.get('arrivalDate').value) ? null : { invalidDate: true };
        }
      }
      ])],
      room: this.fb.array([]),
    });
    this._addRoom();

    this._itineraryService.itinerary$.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  _onSubmit(form: FormGroup, event?: Event, dummy?: Object) {
    if (event) {
      event.preventDefault();
    }
    this._emitLoading(true);
    const payload = searchPayload('DISNEY', '', form, 'ORL');

    const payloadArray = [payload];
    this._restService.doPost('api', '/disney/step/hotels', payload).subscribe(
      Response => {
        console.log('Busqueda exitosa', Response);
        this.payload.emit(payloadArray);
        if (Response !== null && Response.results !== null) {
          this._colocarSearchIdEnlosHoteles(Response);
          this._setArrivalAndDepartureDate(Response, form);
        }
        this._emitOrigin('DISNEY');
        this._handleResponse(Response, 'DISNEY', form);
        this._emitLoading(false);

      //  if  (!this._resultsQuery) {
            this.results.emit(DISNEY);   /// temporal hasta q exista resultados reales
        // }
        this._router.navigate(['/results']);
      },
      Error => {
        this._emitLoading(false);
      });
  }
  _colocarSearchIdEnlosHoteles(response: any) {
    response.results.forEach(obj => {
      obj.searchId = response.searchId;
    });
  }

  _setArrivalAndDepartureDate(response: any, form: FormGroup) {
    response.results.forEach(obj => {
      obj.dateIni = moment(form.value['arrivalDate'].toString().split(',')[0]).format('YYYY-MM-DD');
      obj.dateEnd = moment(form.value['departureDate'].toString().split(',')[0]).format('YYYY-MM-DD');
    });
  }
  _handleResponse(response: any, categoryName: string, form: FormGroup) {
    if (response && response.results != null) {
      try {
        this._resultsQuery = response.results;
        this._resultsQuery.categoryName = categoryName;
        this._resultsQuery.arrivalDate = form.value['arrivalDate'];

        if (!response.results.length) {
          this._resultsQuery.noResultMessage = 'No results found for the search';
        }
        // se anexa el formulario actual
        this._resultsQuery.form = form;
        const arrayResults = [this._resultsQuery];
        this.results.emit(arrayResults);
      } catch (e) {
        this._resultsQuery = [];
        this._restService.page = 1;
      }
    } else {
      this._resultsQuery = [];
      this._resultsQuery.noResultMessage = 'No results found for the search';
      this.results.emit(this._resultsQuery);
    }
  }

  _getQtyAdults(form: FormGroup): Number {
    let qty = 0;
    form.value['room'].forEach(room => {
      qty += Number.parseInt(room['qtyAdults']);
    });
    return qty;
  }

  _getQtyChilds(form: FormGroup): Number {
    let qty = 0;
    form.value['room'].forEach(room => {
      qty += Number.parseInt(room['qtyChilds']);
    });
    return qty;
  }

  _emitOrigin(origin: any) {
    this.origin.emit(origin);
  }

  formArray(form: FormGroup, key: string) { return (<FormArray>form.get(key)).controls; }

  _addRoom() {
    const room = this._form.get('room') as FormArray;
    room.push(this.fb.group({
      qtyAdults: [0, [Validators.required, Validators.min(1)]],
      qtyChilds: [0, Validators.required],
      childsage: this.fb.array([]),
    }));
  }

  _removeRoom(index: number) {
    const room = this._form.get('room') as FormArray;
    room.removeAt(index);
  }


  _addOtherDestinations() {
    setTimeout(() => {
      const destinations: any = this._form.get('othersDestinations') as FormArray;
      const qty: number = +this._form.value['qtyDestination'];
      if (qty > destinations.length) {
        for (let i = destinations.length; i < qty; i++) {
          destinations.push(this.fb.group({
            id: [i],
            destination: ['', Validators.required],
          }));
        }
      } else {
        for (let i = destinations.length - 1; i >= qty; i--) {
          destinations.removeAt(i);
        }
      }
    }, 10);
  }

  _addChild(item: FormGroup) {
    setTimeout(() => {
      const ages: any = item.get('childsage') as FormArray;
      const qty: number = +item.value['qtyChilds'];
      if (qty > ages.length) {
        for (let i = ages.length; i < qty; i++) {
          ages.push(this.fb.group({
            id: [i],
            age: [0, Validators.compose([Validators.required, Validators.min(0), Validators.max(17)])],
          }));
        }
      } else {
        for (let i = ages.length - 1; i >= qty; i--) {
          ages.removeAt(i);
        }
      }
    }, 10);
  }

  _openModal() {
    this.isCollapsed = true;
    this.validate = false;
    this._close = false;
    setTimeout(() => {
      this.modal.emit('true');
    }, 100);
  }
  _over() {
    this.modal.emit('false');
  }

  clickOutside(event: any) {
    this.setRoomAndPassanger();
  }

  _confirm() {
    this.isCollapsed = false;
    this.validate = true;
    this.setRoomAndPassanger();
  }

  setRoomAndPassanger() {
    let rooms = this._form.value['room'].length.toString();
    let adults = this._getQtyAdults(this._form).toString();
    let childs = this._getQtyChilds(this._form).toString();
    let noSelected = (parseInt(adults) === 0 && parseInt(childs) === 0);
    rooms = rooms != undefined ? rooms + " Rooms " : null;
    adults = adults != undefined ? " - " + adults + " Adults " : null;
    childs = childs != undefined ? " - " + childs + " Childs " : null;

    this.roomsAndPassengers = noSelected ? "Rooms and passengers" : rooms + adults + childs;
  }

  _emitLoading(isLoading: boolean) {
    this._findData = isLoading;
    this.isLoading.emit(isLoading);
  }

   async nextDate(event: any){
    if(event!==null){
      await this.datepickerArrival.toggle();
      this.datepickerDeparture.toggle();
      return;
    }
}
}
